/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_ALGOS_UNIVERSAL_REQUEST,
  FETCH_ALGOS_UNIVERSAL_SUCCESS,
  FETCH_ALGOS_UNIVERSAL_FAILURE,
  FETCH_HEALTH_STATUS_SUCCESS,
  FETCH_USERS_BLANK,
  FETCH_ALGO_UNIVERSAL_BY_ID_REQUEST,
  FETCH_ALGO_UNIVERSAL_BY_ID_SUCCESS,
  FETCH_ALGO_UNIVERSAL_BY_ID_FAILURE,
} from '../../constants/ActionTypes';
import { getHealthDataAlgo } from '../../utils';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGOS_UNIVERSAL_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGOS_UNIVERSAL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGOS_UNIVERSAL_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case FETCH_USERS_BLANK:
      return { data: {}, isFetching: false, errorMessage: null };
    case FETCH_HEALTH_STATUS_SUCCESS:
      const healthData = getHealthDataAlgo(action.data);

      const { data = [] } = state.data || {};
      const filterData = data.map((d) => {
        const { status = 'UNKNOWN' } =
          healthData.find((hd) => hd.id === d._id) || {};

        d.algoAPI = status;
        return d;
      });

      state.data.data = filterData;
      return state;
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGO_UNIVERSAL_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGO_UNIVERSAL_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGO_UNIVERSAL_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const algosUniversal = combineReducers({
  list,
  selected,
});

export default algosUniversal;
